import formatCurrency from '@/utils/format-currency';
import { Listing } from '@/utils/platform-api/__generated__/graphql';
import clsx from 'clsx';

export type ListingRateRangeProps = {
  listing: Listing;
  className?: string;
};

export const ListingRateRange: React.FC<ListingRateRangeProps> = ({
  listing,
  className,
}) => {
  if ((listing?.rate_summary?.min_total_nt || 0) > 0) {
    return (
      <div className={clsx(className)}>
        <span className={clsx(`ut-md font-bold !text-success-main`)}>
          {formatCurrency(
            listing?.rate_summary?.min_total_nt || 0,
            false,
            false
          )}
          {listing?.rate_summary?.min_total_nt !==
            listing?.rate_summary?.max_total_nt && (
            <>
              <span className="text-inherit">{' - '}</span>
              {formatCurrency(
                listing?.rate_summary?.max_total_nt || 0,
                false,
                false
              )}
            </>
          )}
        </span>

        <span className="ut-xxs whitespace-nowrap font-medium">
          Average nightly rate before taxes
        </span>
      </div>
    );
  } else {
    return <></>;
  }
};
